import React from 'react';
import { Box, Button, LinearProgress, Paper, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import MenuBookIcon from '@mui/icons-material/MenuBook';

export type KnowledgeBaseRun = { corpus: string; index: string; resolved_indexes: string[]; retrieved: number; selected: number; status: string };
export type EvidenceSelection = { status: string; candidate_count: number; selected_count: number; gaps: string[] };
const labels: Record<string, string> = { standards: 'Standards & regulations', climate: 'Climate & adaptation', industry: 'Industry perspectives', academic: 'Academic research' };
const colors: Record<string, string> = { standards: '#e5bd68', climate: '#68c8de', industry: '#a992e8', academic: '#72ceaa' };

export default function KnowledgeBaseActivity({ bases, selection, onViewSources, pending = false }: { bases?: KnowledgeBaseRun[]; selection?: EvidenceSelection; pending?: boolean; onViewSources?: (corpus: string) => void }) {
  return <Paper variant="outlined" sx={{ p: 2, my: 2, background: 'linear-gradient(120deg, rgba(104,200,222,0.08), rgba(169,146,232,0.08))' }}>
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 1 }}>
      <AutoAwesomeIcon color="primary" />
      <Typography fontWeight={600}>{pending ? 'Finding and assessing evidence…' : 'Knowledge bases consulted'}</Typography>
    </Box>
    {pending ? <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>Searching curated collections, selecting relevant passages and preparing your answer.</Typography>
      <LinearProgress />
    </> : <>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 1.5 }}>
        {bases?.map(base => <Box key={base.corpus} sx={{ p: 1.5, borderRadius: 1, border: '1px solid', borderColor: base.selected ? colors[base.corpus] : 'divider', borderLeftWidth: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <MenuBookIcon sx={{ color: colors[base.corpus] }} fontSize="small" />
            <Typography variant="body2" fontWeight={600}>{labels[base.corpus] || base.corpus}</Typography>
          </Box>
          <Typography variant="caption" color="text.secondary">
            {base.selected ? 'Contributed evidence' : base.status === 'selection_failed' ? 'Evidence assessment unavailable' : base.retrieved ? 'Searched · No relevant evidence selected' : 'Unavailable or empty'}
          </Typography>
          {base.selected > 0 && onViewSources && <Box sx={{ mt: 1 }}><Button size="small" variant="outlined" onClick={() => onViewSources(base.corpus)}>View sources ({base.selected})</Button></Box>}
        </Box>)}
      </Box>
      {selection?.status === 'error' && <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>Evidence assessment is temporarily unavailable. Please retry.</Typography>}
    </>}
  </Paper>;
}
